<template>
  <el-form
    ref="userInfo"
    :model="userInfo"
    :rules="rules"
    class="user-out-info"
    label-width="120px"
    label-position="left"
  >
    <el-form-item label="用户名">
      <span>{{ userInfo.userName }}</span>
      <a
        class="pointer operate-text float-right"
        @click="toPassword"
      >修改密码&gt;&gt;</a>
    </el-form-item>
    <el-form-item label="邮箱">
      <span>{{ userInfo.emial }}</span>
    </el-form-item>
    <el-form-item
      label="真实姓名"
      prop="realName"
    >
      <el-input
        v-model="userInfo.realName"
        :disabled="!edit.realName"
      />
      <i
        v-show="!edit.realName"
        class="el-icon-edit pointer"
        @click="setEdit('realName')"
      />
      <i
        v-show="edit.realName"
        class="el-icon-upload2 pointer"
        @click="saveChange('realName', 'TrueName')"
      />
    </el-form-item>
    <el-form-item
      label="单位名称"
      prop="companyName"
    >
      <el-input
        v-model="userInfo.companyName"
        :disabled="!edit.companyName"
      />
      <i
        v-show="!edit.companyName"
        class="el-icon-edit pointer"
        @click="setEdit('companyName')"
      />
      <i
        v-show="edit.companyName"
        class="el-icon-upload2 pointer"
        @click="saveChange('companyName', 'Employer')"
      />
    </el-form-item>
    <el-form-item
      label="联系电话"
      prop="telPhone"
    >
      <el-input
        v-model="userInfo.telPhone"
        :disabled="!edit.telPhone"
      />
      <i
        v-show="!edit.telPhone"
        class="el-icon-edit pointer"
        @click="setEdit('telPhone')"
      />
      <i
        v-show="edit.telPhone"
        class="el-icon-upload2 pointer"
        @click="saveChange('telPhone', 'Phone')"
      />
    </el-form-item>
    <el-form-item label="会员等级">
      <span>{{ userInfo.vipLevel }}</span>
    </el-form-item>
  </el-form>
</template>

<script>
import {userService} from '@/service/httpService'
import {formValidate} from '@/service/formValidate'
export default {
  data () {
    return {
      edit: {
        realName: false,
        companyName: false,
        telPhone: false
      },
      userInfo: {},
      paramData: {},
      rules: {
        realName: [
          {
            validator (rule, val, callback) {
              formValidate.validateNotNull(val, '真实姓名不能为空', callback)
            },
            trigger: 'change'
          }
        ],
        companyName: [
          {
            validator (rule, val, callback) {
              formValidate.validateNotNull(val, '公司名不能为空', callback)
            },
            trigger: 'change'
          }
        ],
        telPhone: [
          {
            validator: formValidate.validatePhone,
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted () {
    this.initUserInfo()
  },
  methods: {
    initUserInfo () {
      userService.getUserInfo().then(res => {
        let data = res.data
        this.paramData = data
        this.userInfo = {
          userName: data.Name,
          emial: data.Email,
          realName: data.TrueName,
          companyName: data.Employer,
          telPhone: data.Phone,
          vipLevel: data.Level
        }
      })
    },
    setEdit (key) {
      this.edit[key] = true
    },
    toPassword () {
      this.$router.push({
        path: '/resetPassword/0'
      })
    },
    saveChange (key, originKey) {
      this.$refs.userInfo.validate(valid => {
        if (valid) {
          this.paramData[originKey] = this.userInfo[key]

          userService.updateUser(this.paramData)
          .then(res => {
            this.edit[key] = false
            this.$message({type: 'success', message: '修改成功！'})
          })
          .catch(() => {
            this.$message({type: 'error', message: '修改失败'})
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/member-manage-out/user-info.vue